import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Privilege, PrivilegeGroup } from "@/savaradio/common";
export const initialLoading = {
  create: false,
  delete: false,
  update: false,
  get: false,
  find: false,
}
export type IsLoading = Record<keyof typeof initialLoading, boolean>

const initialState: { value?: PrivilegeGroup[], isLoading: IsLoading } = {
  isLoading: initialLoading
}

const privilegeSlice = createSlice({
  name: "privilege_slice",
  initialState,
  reducers: {
    append: (state, action: PayloadAction<Privilege>) => {
      if (!state.value) state.value = [{
        _id: action.payload.operator!,
        count: 1,
        privileges: [action.payload]
      }]
      else {
        const target_privilege_group = state.value.find(privilege_group => privilege_group._id === action.payload.operator)
        if (
          target_privilege_group &&
          !target_privilege_group.privileges.some(item => item._id === action.payload._id)
        ) {
          state.value = state.value.map(privilege_group => {
            if (privilege_group._id === target_privilege_group._id) return {
              ...target_privilege_group,
              count: target_privilege_group.count + 1,
              privileges: [...target_privilege_group.privileges, action.payload]
            }
            else return privilege_group
          })
        }
        if (!target_privilege_group) {
          state.value = [
            ...state.value,
            {
              _id: action.payload.operator!,
              count: 1,
              privileges: [action.payload]
            }
          ]
        }
      }
    },
    pop: (state, action: PayloadAction<Privilege>) => {
      if (state.value) {
        const target_privilege_group = state.value.find(privilege_group => privilege_group._id === action.payload.operator)
        if (target_privilege_group) {
          state.value = state.value.map(privilege_group => {
            if (privilege_group._id === target_privilege_group._id) return {
              ...target_privilege_group,
              count: target_privilege_group.count - 1,
              privileges: target_privilege_group.privileges.filter(privilege => privilege._id !== action.payload._id)
            }
            return privilege_group
          })
          .filter(item => item.privileges.length > 0)
        }
      }
    },
    merge: (state, action: PayloadAction<Privilege>) => {
      if (state.value) {
        const target_privilege_group = state.value.find(privilege_group => privilege_group._id === action.payload.operator)
        if (target_privilege_group) {
          state.value = state.value.map(privilege_group => {
            if (privilege_group._id === target_privilege_group._id) return {
              ...target_privilege_group,
              privileges: target_privilege_group.privileges.map(privilege => privilege._id === action.payload._id ? action.payload : privilege)
            }
            return privilege_group
          }).filter(item => item.privileges.length > 0)
        }
      }
    },
    reset: (state, action: PayloadAction<PrivilegeGroup[] | undefined>) => {
      state.value = action.payload
    },
    setLoading: (state, action: PayloadAction<Partial<IsLoading>>) => {
      state.isLoading = {
        ...state.isLoading, ...action.payload
      }
    }
  }
})

export const { append, pop, merge, reset, setLoading } = privilegeSlice.actions

export const privilege_slice = privilegeSlice.reducer